import { BotProductCardMessage } from '@/types';
import { motion } from 'framer-motion';
import { memo } from 'react';

type MessageProductCardProps = {
  message: BotProductCardMessage;
  messageId: string;
};

const MessageProductCard = ({ message, messageId }: MessageProductCardProps) => {
  return (
    <motion.a
      href={message.content.link || '#'}
      target="_blank"
      rel="noopener noreferrer"
      className="flex max-w-full flex-col"
      layoutId={`${messageId}-product-card`}
      key={`${messageId}`}
    >
      <img
        src={message.content.image}
        alt={message.content.name}
        className="aspect-[252/168] max-h-[300px] max-w-full rounded-md object-cover"
      />
      {message.content.tags && (
        <div className="mt-[12px] flex flex-wrap gap-[4px]">
          {message.content.tags.map(tag => (
            <span
              key={tag}
              className="rounded-[20px] bg-widget-gray-100 px-[8px] py-[2px] text-sm font-medium text-widget-gray-700"
            >
              {tag}
            </span>
          ))}
        </div>
      )}
      <div className="mt-[8px] flex flex-col">
        <p className="text-text-primary text-sm font-semibold">{message.content.name}</p>
        <div className="flex gap-[12px]">
          <p className="text-text-tertiary mt-[2px] text-lg font-bold">{message.content.price}</p>
          <span className="flex items-center rounded-[20px] bg-widget-warning px-[8px] py-[2px] text-[12px] font-semibold leading-[12px] text-widget-white">
            {message.content.salePercentage}%
          </span>
        </div>
      </div>
    </motion.a>
  );
};

export default memo(MessageProductCard);
